import React from "react"
import PreviewPopoverLink from '../../PreviewPopover/PreviewPopoverLink'

export default class AppliedToDataType extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    if (!this.props.data) {
      return I18n.t('none')
    } else if (this.props.data.text_only == true) {
      return <div>{this.props.data.text}</div>
    } else {
      return(
        <PreviewPopoverLink model_type={this.props.data.model_type} model_id={this.props.data.model_id} text={this.props.data.text} date_format={this.props.date_format} time_format={this.props.time_format} popoverEndpoint={this.props.data.popoverEndpoint} />
      );
    };
  };

};